/**
 * UserPreviewDialogController
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { UserPresenter } from '../user-presenter';

UserPreviewDialogController.$inject = ['$userFetcher', '$mdDialog', '$scope', '$util', 'user'];

function UserPreviewDialogController($userFetcher, $mdDialog, $scope, $util, user) {
    // Properties
    $scope.user = user;

    // Methods
    $scope.close = close;

    // Main
    fetchUser();

    // Make sure user has a presenter
    if (!$scope.user.$presenter) {
        $scope.user.$presenter = new UserPresenter($scope.user);
    }

    // Functions

    /**
     * Close this dialog.
     * @param  {MouseEvent} $event
     * @return {void}
     */
    function close() {
        $mdDialog.cancel();
    }

    function fetchUser() {
        $userFetcher
            .get($scope.user.id, {
                include: ['person'],
            })
            .then(
                $util.nextTick(result => {
                    const user = result.data;

                    user.$presenter = new UserPresenter(user);

                    $scope.user = user;
                }),
            );
    }
}

export default UserPreviewDialogController;
